import React from "react";
import { supportLink, supportMessage } from "../utils/support";
import { useOwnezzyContact } from "../utils/branding";

// Floating "chat with support" button, bottom right on every admin page
export default function WhatsAppSupport({ user }) {
    const contact = useOwnezzyContact();
    return (
        <a className="whatsapp-support" href={supportLink(supportMessage(user), contact.whatsapp)} target="_blank" rel="noreferrer" aria-label="Chat with Ownezzy support on WhatsApp">
            <svg viewBox="0 0 32 32" width="26" height="26" aria-hidden="true" fill="currentColor">
                <path d="M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 7L3 29l6.4-2c2 1.1 4.3 1.7 6.6 1.7 7.2 0 13-5.7 13-12.8S23.2 3 16 3zm0 23.4c-2.1 0-4.1-.6-5.9-1.7l-.4-.3-3.8 1.2 1.2-3.7-.3-.4c-1.2-1.8-1.9-3.9-1.9-6.1C4.9 9.8 9.9 5 16 5s11.1 4.8 11.1 10.8S22.1 26.4 16 26.4zm6.1-8c-.3-.2-2-1-2.3-1.1-.3-.1-.5-.2-.8.2-.2.3-.9 1.1-1.1 1.3-.2.2-.4.3-.7.1-.3-.2-1.4-.5-2.7-1.7-1-.9-1.7-2-1.9-2.3-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.3.3-.6.1-.2 0-.4 0-.6l-1-2.5c-.3-.7-.6-.6-.8-.6h-.7c-.2 0-.6.1-.9.4-.3.3-1.2 1.2-1.2 2.9s1.2 3.4 1.4 3.6c.2.2 2.4 3.7 5.9 5.1 2.9 1.1 3.5.9 4.1.8.6-.1 2-.8 2.3-1.6.3-.8.3-1.5.2-1.6-.1-.2-.3-.3-.6-.4z" />
            </svg>
            <span>Need help?</span>
        </a>
    );
}
